import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStop = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 18C7.45 18 6.97933 17.8043 6.588 17.413C6.196 17.021 6 16.55 6 16V8C6 7.45 6.196 6.97933 6.588 6.588C6.97933 6.196 7.45 6 8 6H16C16.55 6 17.021 6.196 17.413 6.588C17.8043 6.97933 18 7.45 18 8V16C18 16.55 17.8043 17.021 17.413 17.413C17.021 17.8043 16.55 18 16 18H8ZM8 16H16V8H8V16Z",
		fill: "currentColor"
	})
});
export default SvgStop;
